import { WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';

import { IOnGoingELearning, IResultELearning } from '../actions/imstat';
import { ElearningTypes } from '../components/ELearningCard';
import CardPagination from './CardPagenation';
import ELearningCard from './ELearningCard';

const styles = (theme: Theme) =>
	createStyles({
		pagination: {
			marginTop: theme.spacing(2),
		},
	});

interface IProps
	extends React.Props<{}>,
		WithStyles<typeof styles>,
		IImstatELearningCardProps {}
interface IState {
	startRowIndex: number;
	endRowIndex: number;
}

/**
 * eラーニングカード形式
 */
class ImstatELearningCard extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			endRowIndex: 4,
			startRowIndex: 0,
		};
	}

	public render() {
		const displayData = this.getDisplayData();
		return (
			<>
				<Grid
					container={true}
					spacing={1}
					direction="row"
					justify="center"
					alignItems="stretch"
				>
					{this.props.type === ElearningTypes.ONGOING &&
						(displayData as IOnGoingELearning[]).map((datum, i) => (
							<Grid key={i} item={true}>
								<ELearningCard
									IOnGoingData={datum}
									type={this.props.type}
								/>
							</Grid>
						))}
					{this.props.type === ElearningTypes.RESULT &&
						(displayData as IResultELearning[]).map((datum, i) => (
							<Grid key={i} item={true}>
								<ELearningCard
									IResultData={datum}
									type={this.props.type}
								/>
							</Grid>
						))}
				</Grid>
				<CardPagination
					onPageChange={this.handleChangePage}
					dataSize={this.props.data.length}
					className={this.props.classes.pagination}
				/>
			</>
		);
	}

	/**
	 * ページ変更時処理
	 */
	protected handleChangePage = (
		startRowIndex: number,
		endRowIndex: number
	) => {
		this.setState({ endRowIndex, startRowIndex });
	};

	/**
	 * 表示データ取得処理
	 */
	protected getDisplayData() {
		const { endRowIndex, startRowIndex } = this.state;
		const displayData = this.props.data.slice(
			startRowIndex,
			endRowIndex + 1
		);
		return displayData;
	}
}

interface IImstatELearningCardProps {
	data: IOnGoingELearning[] | IResultELearning[];
	type: ElearningTypes;
}

export default withStyles(styles)(ImstatELearningCard);



// WEBPACK FOOTER //
// ./src/components/ImstatELearningCard.tsx